import React from 'react';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import { Tooltip } from 'components/Tooltip';
import { FormikField } from 'components/FormikField';

import { PropertySelectField } from '../PropertySelectField';

import {
  getPropertyIconName,
  getPropertyValue,
} from './IconTextProperty.helpers';

import styles from './IconTextProperty.module.scss';

const _renderField = ({
  namePrefix,
  readOnly,
  property,
  dependProperty,
  onChanged,
}: {
  namePrefix: any;
  readOnly: any;
  property: any;
  dependProperty: any;
  onChanged: any;
}) => (
  <FormikField
    name={namePrefix}
    withControl={false}
    component={PropertySelectField}
    componentProps={{
      type: 'checkbox',
      readOnly,
      property,
      dependProperty,
      renderProperty: _renderContent,
      onChanged,
    }}
  />
);

const _renderContent = ({
  key,
  value,
  dependValue,
}: {
  key: any;
  value: any;
  dependValue: any;
}) => (
  <>
    <Icon
      className={styles.icon}
      name={getPropertyIconName({
        type: key,
        value,
      })}
    />
    <Typography
      className={styles.value}
      variant="body2"
      weight="medium"
      mode="compact"
    >
      {getPropertyValue({ type: key, value, dependValue })}
    </Typography>
  </>
);

const IconTextProperty = ({
  isInitialState,
  readOnly,
  checkable,
  tooltip,
  designType,
  namePrefix,
  property,
  dependProperty,
  onChanged,
}: {
  isInitialState: any;
  readOnly: any;
  checkable?: boolean;
  tooltip: any;
  designType: any;
  namePrefix: any;
  property: any;
  dependProperty: any;
  onChanged: any;
}) => {
  if (!property) {
    return null;
  }

  if (isInitialState || (designType === 'PROTOTYPE' && !checkable)) {
    if (tooltip) {
      return (
        <Tooltip
          text={tooltip}
          triggerElement={
            <div className={styles.propertyReadOnly}>
              {_renderContent({
                key: property.key,
                value: property.value,
                dependValue: dependProperty ? dependProperty.value : null,
              })}
            </div>
          }
        />
      );
    }

    return (
      <div className={styles.propertyReadOnly}>
        {_renderContent({
          key: property.key,
          value: property.value,
          dependValue: dependProperty ? dependProperty.value : null,
        })}
      </div>
    );
  }

  if (tooltip) {
    return (
      <Tooltip
        text={tooltip}
        triggerElement={_renderField({
          namePrefix,
          readOnly,
          property,
          dependProperty,
          onChanged,
        })}
      />
    );
  }

  return _renderField({
    namePrefix,
    readOnly,
    property,
    dependProperty,
    onChanged,
  });
};

export default React.memo(IconTextProperty) as any;
